"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var UserGroupStore = /*#__PURE__*/function (_RootStore) {
  function UserGroupStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, UserGroupStore);
    _this = _callSuper(this, UserGroupStore);
    _this.config = {
      model: _models.UserGroup,
      deserialize: true,
      GET: {
        index: '/groups/:groupId/user_groups'
      },
      PUT: {
        update: 'user_groups/:userGroupId'
      },
      POST: {
        create: 'user_groups',
        add_user: 'user_groups/add_user',
        add_admin: 'user_groups/add_admin',
        batch_remove_user: '/groups/:groupId/user_groups/batch_remove_user',
        calculate_user_removal: '/groups/:groupId/user_groups/calculate_user_removal'
      },
      DELETE: {
        destroy: 'user_groups/:userGroupId',
        remove_admin: 'user_groups/:userGroupId/remove_admin'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(UserGroupStore, _RootStore);
  return (0, _createClass2["default"])(UserGroupStore, [{
    key: "calculateUserRemoval",
    value: function calculateUserRemoval(params, callback) {
      this.api(params, callback, 'POST', 'calculate_user_removal');
    }
  }, {
    key: "addUser",
    value: function addUser(params, callback) {
      if (params.data.password) {
        params.data.password_confirmation = params.data.password;
      }
      this.api(params, callback, 'POST', 'add_user');
    }
  }, {
    key: "addAdmin",
    value: function addAdmin(params, callback) {
      this.api(params, callback, 'POST', 'add_admin');
    }
  }, {
    key: "removeAdmin",
    value: function removeAdmin(params, callback) {
      this.api(params, callback, 'DELETE', 'remove_admin');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new UserGroupStore();